import { chain, identity } from 'lodash';
import { ASSET_TYPES } from '../../../shared/constants';
import { convertAssetThumbnail } from '../../../utils';

/**
 * @param {gitType['attachments']} attachments
 * @param {string} attachmentId
 */
export const invokeCloudImage = (attachments, attachmentId) =>
    chain(attachments).find({ id: attachmentId }).get('image_url').value();

/**
 * @param {gitType['assets']} assets
 * @param {gitType['attachments']} attachments
 * @returns
 */
export const getImagePreview = (assets = [], attachments = []) => {
    const imageUrls = chain(assets)
        .orderBy('type', 'desc')
        .map((item) =>
            item.type !== ASSET_TYPES.IMAGE
                ? invokeCloudImage(attachments, item.attachment_id)
                : item.cloud_img_main_gig
        )
        .filter(identity)
        .value();

    return convertAssetThumbnail(imageUrls[0]);
};
